"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SearchIcon_1 = __importDefault(require("../icons/SearchIcon"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Loader_1 = __importDefault(require("./Loader"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-bottom: 0.0625rem dashed rgb(187, 187, 187);
  height: 48px;
  width: 100%;
  background-color: transparent;

  > input {
    height: 48px;
    width: 100%;
    background-color: transparent;
    font-size: 1rem;
    font-weight: 500;
    border: 0;
    outline: 0px;
  }
`;
const SearchBar = ({ value, onChange, loading }) => {
    return (react_1.default.createElement(Wrapper, null,
        loading ? react_1.default.createElement(Loader_1.default, { size: "l" }) : react_1.default.createElement(SearchIcon_1.default, null),
        react_1.default.createElement("input", { onChange: (e) => {
                onChange(e.target.value);
            }, value: value, placeholder: "Vyh\u013Eadajte organiz\u00E1ciu..." })));
};
exports.default = SearchBar;
